import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import { getStateByCountryFailure, getStateByCountrySuccess } from '../../actions/CampaignMasterActions/getStateByCountryActions';

function* getStateByCountry({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'get',
            base_url: base_url,
            endPoint: endpoints.getStateByCountry + `${payload?.countryId}`,
            isAuth: true,
        });
        console.log('====================================');
        console.log("GET_STATE_BY_COUNTRY_SUCCESS status :", response.data.status);
        console.log("GET_STATE_BY_COUNTRY_SUCCESS data :", response.data.response);
        console.log("GET_STATE_BY_COUNTRY_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            getStateByCountrySuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("GET_STATE_BY_COUNTRY_FAILURE status :", error?.response?.status);
        console.log("GET_STATE_BY_COUNTRY_FAILURE data:", error?.response?.data);
        console.log("GET_STATE_BY_COUNTRY_FAILURE error :", error);
        console.log('====================================');
        yield put(getStateByCountryFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* getStateByCountrySaga() {
    yield takeLatest(actionTypes.GET_STATE_BY_COUNTRY_REQUEST, getStateByCountry);
}

export default getStateByCountrySaga;